import React from 'react';
import first from 'lodash/first';
import last from 'lodash/last';

import ActionItem from 'Shared/components/ActionItem/ActionItem';
import { WorkspaceItem } from 'Shared/constants/types';

type Props = {
  forbidDrag?: boolean;
  actionItems: Array<WorkspaceItem>;
  listOfParentUuid?: string;
  withWorkspaceSection?: boolean;
  withDueDateSection?: boolean;
  withOwnerSection?: boolean;
  isDisabled?: boolean;
  isCompleteToggleDisabled?: boolean;
  isYourActionItemPage?: boolean;
  onNestByDrag: Function;
  nestItemByTabClick: Function;
  onArrowUpClick: Function;
  onArrowDownClick: Function;
  onAddItem: Function;
  onActionItemDrop?: Function;
  forceShowMobileActions?: boolean;
};

function ActionItemsList({
  actionItems,
  forbidDrag = false,
  listOfParentUuid = null,
  withWorkspaceSection = true,
  withDueDateSection = true,
  withOwnerSection = false,
  isDisabled = false,
  isCompleteToggleDisabled = false,
  nestItemByTabClick,
  onNestByDrag,
  onArrowUpClick,
  onArrowDownClick,
  onAddItem,
  onActionItemDrop,
  forceShowMobileActions,
}: Props) {
  const filteredItems = actionItems.filter(({ parentUuid }) => parentUuid === listOfParentUuid);
  const itemsWithoutHighPriority = filteredItems.filter(({ isHighPriority }) => !isHighPriority);
  const hasHighPriorityItems = Boolean(filteredItems.length - itemsWithoutHighPriority.length);
  const firstItemUuid = itemsWithoutHighPriority.length ? first(itemsWithoutHighPriority).uuid : null;
  const lastItemUuid = itemsWithoutHighPriority.length ? last(itemsWithoutHighPriority).uuid : null;

  return (
    <>
      {filteredItems.map(({ uuid }) => (
        <ActionItem
          useNestingDnd
          enableHideAnimation
          withWorkspaceSection={withWorkspaceSection}
          withDueDateSection={withDueDateSection}
          withOwnerSection={withOwnerSection}
          isDisabled={isDisabled}
          isCompleteToggleDisabled={isCompleteToggleDisabled}
          key={uuid}
          forbidDrag={forbidDrag}
          onNestByDrag={onNestByDrag}
          uuid={uuid}
          nestItemByTabClick={nestItemByTabClick}
          isFirst={firstItemUuid === uuid}
          isLast={uuid === lastItemUuid}
          hasHighPriorityItems={!forbidDrag && hasHighPriorityItems}
          onArrowUpClick={onArrowUpClick}
          onArrowDownClick={onArrowDownClick}
          selector="meetingItems"
          onDrop={onActionItemDrop}
          onAddItem={onAddItem}
          forceShowMobileActions={forceShowMobileActions}
        >
          {actionItems.some(t => t.parentUuid === uuid) ? (
            <ActionItemsList
              listOfParentUuid={uuid}
              forbidDrag={forbidDrag}
              actionItems={actionItems}
              onAddItem={onAddItem}
              onNestByDrag={onNestByDrag}
              onArrowUpClick={onArrowUpClick}
              nestItemByTabClick={nestItemByTabClick}
              onArrowDownClick={onArrowDownClick}
              withWorkspaceSection={withWorkspaceSection}
              withDueDateSection={withDueDateSection}
              withOwnerSection={withOwnerSection}
              isDisabled={isDisabled}
              isCompleteToggleDisabled={isCompleteToggleDisabled}
              onActionItemDrop={onActionItemDrop}
              forceShowMobileActions={forceShowMobileActions}
            />
          ) : null}
        </ActionItem>
      ))}
    </>
  );
}

export default React.memo(ActionItemsList);
